var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.503 2.627L1.5 4.75V15.254C1.5 16.116 1.84241 16.9426 2.4519 17.5521C3.0614 18.1616 3.88805 18.504 4.75 18.504H13.366C13.2107 18.9427 12.9233 19.3225 12.5433 19.5911C12.1633 19.8598 11.7094 20.004 11.244 20.004H4.75C3.49022 20.004 2.28204 19.5036 1.39124 18.6128C0.500445 17.722 0 16.5138 0 15.254V4.75C0 3.77 0.627 2.935 1.503 2.627ZM13.75 0C14.0455 0 14.3381 0.058198 14.611 0.171271C14.884 0.284344 15.1321 0.450078 15.341 0.65901C15.5499 0.867941 15.7157 1.11598 15.8287 1.38896C15.9418 1.66194 16 1.95453 16 2.25V15.25C16 15.5455 15.9418 15.8381 15.8287 16.111C15.7157 16.384 15.5499 16.6321 15.341 16.841C15.1321 17.0499 14.884 17.2157 14.611 17.3287C14.3381 17.4418 14.0455 17.5 13.75 17.5H4.75C4.15326 17.5 3.58097 17.2629 3.15901 16.841C2.73705 16.419 2.5 15.8467 2.5 15.25V2.25C2.5 1.65326 2.73705 1.08097 3.15901 0.65901C3.58097 0.237053 4.15326 0 4.75 0H13.75Z",
    fill: "#C0C3C6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.793c707e2dae2d09663fcfc141202139.svg";
export { ForwardRef as ReactComponent };